import { render } from "./Appreciation.vue?vue&type=template&id=035e11de&scoped=true"
import script from "./Appreciation.vue?vue&type=script&lang=js"
export * from "./Appreciation.vue?vue&type=script&lang=js"

import "./Appreciation.vue?vue&type=style&index=0&id=035e11de&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035e11de"]])

export default __exports__